import moment, { Moment } from "moment";

import { MentorShiftsQuery } from "../shifts/graphql/mentorShifts.generated";

import { TMentorShiftScheduleEvent } from "./constants";
import { TMentorShiftSchedule } from "./types";

export const parseMaxCountRestriction = (input: any): number => {
  if (input) {
    try {
      return input?.mentor?.max_count ?? 0;
    } catch (err) {
      console.error(err);
      return 0;
    }
  }

  return 0;
};

export const parseAdminShifts = (
  mentorShiftsData: MentorShiftsQuery
): TMentorShiftSchedule[] => {
  return mentorShiftsData.mentorShifts.map((shift) => {
    const maxCount = parseMaxCountRestriction(shift.restrictions);
    const spots_left = maxCount - (shift.shift_signups?.length ?? 0);

    return {
      shift: shift.name,
      shift_id: shift.id,
      date: new Date(shift.start_time).toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
      }),
      time_start: new Date(shift.start_time),
      time_end: new Date(shift.end_time),
      spots_left: Math.max(spots_left, 0),
      required_mentors: maxCount,
    };
  }) as TMentorShiftSchedule[];
};

export const blocksFromTop = (momentStart: Moment) => {
  return moment
    .duration(momentStart.diff(moment.tz("2026-09-18", "America/New_York")))
    .asHours();
};

export const sortComputedShifts = (
  computedShifts: TMentorShiftScheduleEvent[]
): void => {
  const columns: {
    start: moment.Moment;
    end: moment.Moment;
  }[][] = [];

  computedShifts.forEach((shift) => {
    let placed = false;

    for (let i = 0; i < columns.length; i++) {
      let fits = true;

      for (let j = 0; j < columns[i].length; j++) {
        const other = columns[i][j];
        if (shift.start.isBefore(other.end) && shift.end.isAfter(other.start)) {
          fits = false;
          break;
        }
      }

      if (fits) {
        columns[i].push({
          start: shift.start,
          end: shift.end,
        });
        shift.overlapColumn = i;
        placed = true;
        break;
      }
    }

    if (!placed) {
      columns.push([{ start: shift.start, end: shift.end }]);
      shift.overlapColumn = columns.length - 1;
    }
  });
};

export const handleDownloadCSV = (
  data: TMentorShiftSchedule[],
  filename: string
) => {
  if (!data || data.length === 0) return;

  const headers = Object.keys(data[0]);
  const csvRows = [
    [...headers].join(","),
    ...data.map((row) =>
      [...headers.map((header) => `"${(row as any)[header]}"`)].join(",")
    ),
  ];

  const csvContent = csvRows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename + ".csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
